// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"0c08da5afda2d713","888":"d1b9b62072a77c06"}[chunkId] + ".css";
};